import { useDispatch } from 'react-redux';

import { P2, P3 } from '../../styles/FontStyles';

import { colors } from '../../styles/GlobalStyles';

import { useAppSelector } from '../../app/hooks';
import creditCardWithButton from '../../assets/images/backoffice/buyWithCreditCard.png';
import { Flexed } from '../../styles/GlobalComponents';

interface CreditCardType {
  amount: number;
  paymentAddress: string;
}

export const CreditCard = ({ amount, paymentAddress }: CreditCardType) => {
  const dispatch = useDispatch();
  const { user } = useAppSelector((state) => state.auth.userInfo);

  return (
    <div>
      <Flexed justifyCenter>
        <P2 mb='20' mt='20'>
          OR
        </P2>
      </Flexed>
      <img
        src={creditCardWithButton}
        style={{ width: '100%', cursor: 'pointer' }}
        onClick={() => {
          window.open(
            `https://bank.arkfi.io/usdtpurchase?direct=true&email=${user.email}&amount=${amount}&address=${paymentAddress}`
          );
        }}
      />
      <P3 mb='8' mt='20' color={colors.neutral900}>
        After your transaction is received and approved, your order will be
        activated.
      </P3>
      <P3 mb='8' mt='20' color={colors.neutral900}>
        Activation of your order can take up to 48 hours. When activated, you
        will be notified by email.
      </P3>
    </div>
  );
};
